/* eslint-disable @typescript-eslint/no-unused-vars */
import storeInfo from '../../ducks/store'
import { ConfigType } from './types'

export const getConfigValue = (type: string) => (): any => {
  const { config } = storeInfo.store.getState()
  return config[type as keyof ConfigType] || null
}
